'use strict';

var extractAlpha = {};

exports.__exports = extractAlpha;
//# sourceMappingURL=extractAlpha.cjs.map
